"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OpenModalMobile = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Text = _interopRequireDefault(require("../Text"));
var _bottomSheet = _interopRequireDefault(require("./bottom.sheet.proptypes"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
/* eslint-disable no-nested-ternary */

const OpenModalMobile = props => (0, _styledComponents.keyframes)(["0%{opacity:0;height:0;}25%{opacity:0.25;}50%{opacity:0.5;}75%{opacity:0.75;}100%{opacity:1;height:", "}"], props.height);
exports.OpenModalMobile = OpenModalMobile;
const BottomSheetOverlay = _styledComponents.default.div.withConfig({
  displayName: "BottomSheet__BottomSheetOverlay",
  componentId: "sc-5ceq86-0"
})(_ref => {
  let {
    theme,
    backgroundColor,
    opacity,
    zIndex
  } = _ref;
  return "\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: ".concat(theme.backgroundColor[backgroundColor], ";\n    z-index: ").concat(zIndex, ";\n    opacity: ").concat(opacity, ";\n  ");
});
BottomSheetOverlay.displayName = 'BottomSheetOverlay';
const CloseBtnWrapper = _styledComponents.default.div.withConfig({
  displayName: "BottomSheet__CloseBtnWrapper",
  componentId: "sc-5ceq86-1"
})(["position:absolute;top:", ";", ":", ";cursor:pointer;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.space.semi;
}, _ref3 => {
  let {
    closeBtnAlignment
  } = _ref3;
  return closeBtnAlignment;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.space.standard;
});
CloseBtnWrapper.displayName = 'BottomSheetCloseBtnWrapper';
const BottomSheetWrapper = _styledComponents.default.div.withConfig({
  displayName: "BottomSheet__BottomSheetWrapper",
  componentId: "sc-5ceq86-2"
})(["width:100%;position:fixed;overflow-y:auto;bottom:", ";left:", ";border-radius:", " box-sizing:border-box;overscroll-behavior:contain;", ""], _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.space.none;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.space.none;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return "".concat(theme.space.XXXSmall, "  ").concat(theme.space.XXXSmall, " ").concat(theme.space.none, " ").concat(theme.space.none);
}, props => (0, _styledComponents.css)(["background-color:", ";z-index:", ";animation:", " ", "s linear 0s 1 normal forwards;height:", ";border-radius:", ";"], props.theme.colors[props.background] || props.theme.colors.default, props.zIndex, props.isAnimationOn && OpenModalMobile(props.height), props.animationDuration, props.height, _ref8 => {
  let {
    theme,
    withContainerRadius
  } = _ref8;
  return withContainerRadius ? "".concat(theme.space.XXXSmall, "  ").concat(theme.space.XXXSmall, " ").concat(theme.space.none, " ").concat(theme.space.none) : "unset";
}));
const HeaderContainer = _styledComponents.default.div.withConfig({
  displayName: "BottomSheet__HeaderContainer",
  componentId: "sc-5ceq86-3"
})(["display:flex;justify-content:space-between;flex-direction:row;padding:", ";background:", ";box-shadow:", ";position:", ";top:", ";z-index:", ";"], _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.space.small;
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.backgroundColor.default;
}, _ref11 => {
  let {
    theme,
    showHeaderContainerShadow
  } = _ref11;
  return showHeaderContainerShadow && "".concat(theme.space.none, " ").concat(theme.space.mini, " 6px rgba(0, 0, 0, 0.2)");
}, _ref12 => {
  let {
    fixedHeader
  } = _ref12;
  return fixedHeader ? 'sticky' : 'relative';
}, _ref13 => {
  let {
    fixedHeader
  } = _ref13;
  return fixedHeader ? '0' : 'unset';
}, _ref14 => {
  let {
    fixedHeader
  } = _ref14;
  return fixedHeader ? '100' : 'auto';
});
const HeaderTitleWrapper = _styledComponents.default.div.withConfig({
  displayName: "BottomSheet__HeaderTitleWrapper",
  componentId: "sc-5ceq86-4"
})(["display:flex;justify-content:space-between;"]);
const CloseWrapper = _styledComponents.default.div.withConfig({
  displayName: "BottomSheet__CloseWrapper",
  componentId: "sc-5ceq86-5"
})(["display:flex;justify-content:space-between;top:", ";cursor:pointer;"], _ref15 => {
  let {
    theme
  } = _ref15;
  return theme.space.semi;
});
const BottomSheet = /*#__PURE__*/_react.default.memo(props => {
  const {
    show,
    theme,
    isAnimationOn,
    animationDuration,
    children,
    background,
    zIndex,
    height,
    onClose,
    accessible,
    showOverlay,
    overlayBackgroundColor,
    overlayOpacity,
    showCloseBtn,
    closeBtnAlignment,
    customProperties,
    headerTitle,
    withContainerRadius,
    fixedHeader,
    showHeaderContainerShadow
  } = props;
  const themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  const [bottomSheetShow, setBottomSheetShow] = (0, _react.useState)(show);
  const overlayZindex = zIndex - 1;
  (0, _react.useEffect)(() => {
    setBottomSheetShow(show);
  }, [show]);
  const closeHandler = e => {
    if (onClose) {
      onClose(e);
    }
    setBottomSheetShow(false);
  };
  const returnCloseButton = () => {
    return /*#__PURE__*/_react.default.createElement(CloseBtnWrapper, {
      onClick: closeHandler,
      closeBtnAlignment: closeBtnAlignment
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      fontsize: "titleNormal",
      icon: "CloseIcon",
      color: "greyDark",
      accessible: accessible,
      theme: theme
    }));
  };
  const returnHeader = () => {
    return /*#__PURE__*/_react.default.createElement(HeaderContainer, {
      fixedHeader: fixedHeader,
      showHeaderContainerShadow: showHeaderContainerShadow
    }, /*#__PURE__*/_react.default.createElement(HeaderTitleWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      bold: true
    }, headerTitle)), /*#__PURE__*/_react.default.createElement(CloseWrapper, {
      onClick: closeHandler,
      closeBtnAlignment: closeBtnAlignment
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      fontsize: "titleNormal",
      icon: "CloseIcon",
      color: "greyDark",
      accessible: accessible,
      theme: theme
    })));
  };
  const getMain = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, bottomSheetShow && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showOverlay && /*#__PURE__*/_react.default.createElement(BottomSheetOverlay, {
      onClick: closeHandler,
      backgroundColor: overlayBackgroundColor,
      opacity: overlayOpacity,
      zIndex: overlayZindex
    }), /*#__PURE__*/_react.default.createElement(BottomSheetWrapper, (0, _extends2.default)({
      zIndex: zIndex,
      height: height,
      isAnimationOn: isAnimationOn,
      animationDuration: animationDuration,
      background: background
    }, customProperties, {
      withContainerRadius: withContainerRadius
    }), showCloseBtn && headerTitle !== '' ? returnHeader() : showCloseBtn ? returnCloseButton() : null, children)));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
});
BottomSheet.propTypes = _bottomSheet.default.PropTypes;
BottomSheet.defaultProps = _bottomSheet.default.DefaultProps;
var _default = exports.default = BottomSheet;